import {lazy} from "react";

export const LazyReportBuilder = lazy(() => import('./ReportBuilder'))